'use client';

import * as amplitude from '@amplitude/analytics-browser';
import {
  SessionReplayPlugin,
  sessionReplayPlugin,
} from '@amplitude/plugin-session-replay-browser';
import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { useCompleteTrackingContext } from '@hc-frontend/features-tracking';
import { useEffect } from 'react';

import { sessionReplayManager } from '../../../utils/session-replay-manager';

export function AmplitudeSessionReplay() {
  const context = useCompleteTrackingContext();
  const config = getClientApplicationConfig();

  async function initialize(env: string, apiKey: string, domainUserId: string) {
    await amplitude.init(apiKey, domainUserId, {
      autocapture: {
        sessions: true,
        attribution: false,
        pageViews: false,
        formInteractions: false,
        fileDownloads: false,
        elementInteractions: false,
        frustrationInteractions: true,
      },
    }).promise;

    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: 0.2,
    });

    amplitude.add(sessionReplayTracking);

    // Initialize the global session replay manager with the plugin instance
    sessionReplayManager.initialize(
      sessionReplayTracking as SessionReplayPlugin,
    );
  }

  useEffect(() => {
    initialize(
      config.core.appEnvironment,
      config.amplitude.identify.apiKey,
      context.tracker.getDomainUserId(),
    );
  }, []);

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionReplayManager.flushSync();
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);

  return null;
}
